/*
 * @Author: your name
 * @Date: 2022-01-05 14:17:59
 * @LastEditTime: 2022-01-25 00:39:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \longzhu-PC\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import { Card,Form,Drawer,Radio,Tabs,TabPane,Progress,Cascader,FormItem,Option,Button, Select ,Col,Row,Input,Breadcrumb,BreadcrumbItem,Collapse,CollapseItem,RadioGroup,RadioButton,DatePicker,Result,Upload,Dialog,Message,TableColumn,Table} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './element-variables.scss'

import ElementUI from 'element-ui';
import App from './App'
import router from './router'
import jquery from 'jquery'
Vue.prototype.$ = jquery
import * as filters from './filters/index'
      let patams = {
        "device": "",
        "channel": "",
        "grayTheme": true,
        "minimumVersion": "",
        "currentVersion": "",
        "popUp": 0,
        "popupContent": "",
        "forceUpdate": 0,
        "hideModule": "",
        "downloadUrl": "",
        "createTime": 0
      }
      localStorage.setItem('userSettingInfo',JSON.stringify(patams));
// 全屏滚动 vue-fullpage.js
import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js/dist/vue-fullpage.js'
Vue.use(VueFullPage)

  import {getBrowser,MyNewRouter} from '@/lib/tools.js';
  console.log('浏览器版本检测',getBrowser());
  let myBrower = getBrowser();

  import { vueBaberrage } from 'vue-baberrage'


  // let Module = null;
  // let vueBaberrage = null;

// if (myBrower === "chrome") {
//   Module = require("vue-baberrage");
//   vueBaberrage = Module.vueBaberrage;
// }
import  URLS from "@/api/lz.js"

import store from './store'//引入store

import vhCheck from 'vh-check';
vhCheck('browser-address-bar');
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
import md5 from 'js-md5'
Vue.prototype.$md5 = md5;
import axios from 'axios'
import VueRouter from 'vue-router';


import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import 'videojs-contrib-hls'


Vue.use(VideoPlayer);
 Vue.use(vueBaberrage)

// 添加响应拦截器
axios.interceptors.response.use((response)=> {
  // 对响应数据做点什么
  if(response.data && response.data.code == 200){
    return response
  }
  // 用户封禁
  if(response.data && response.data.code == 20024){
    if(router.currentRoute.name !='HelloWorld'){
       router.replace('/')
    }
    localStorage.clear();
  }

  // 1001-1010

  // 重新登录
  if(response.data && response.data.code >= 1001 && response.data.code <=1010 ){
    localStorage.clear();
    router.replace('/')
  }
  return response
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
});



// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$axios = axios;
Vue.prototype.$store = store;
Vue.prototype.$NewRouter = MyNewRouter;



// 域名跳转地址
Vue.prototype.Tourl =  document.location.host  //'http://kanlongzhu.com' //线上环境

// 测试
// Vue.prototype.api = 'http://t-api.ansongqiubo.com' //测试环境
// Vue.prototype.ws = 'ws://t-chat.ansongqiubo.com/websocketServer'//测试环境websocket
// Vue.prototype.payGateway = 'http://t-pay-gateway.ansongqiubo.com' //测试环境充值

// 预发布
// Vue.prototype.api = 'http://o-api.ansongqiubo.com' //测试环境
// Vue.prototype.ws = 'wss://chat.ansongqiubo.com/websocketServer'//测试环境websocket
// Vue.prototype.payGateway = 'https://pay-gateway.ansongqiubo.com' //测试环境充值

// 生产
// Vue.prototype.payGateway = 'https://pay-gateway.ansongqiubo.com' //线上环境充值
// Vue.prototype.api ='https://api.ansongqiubo.com' //线上环境
// Vue.prototype.ws = 'wss://chat.ansongqiubo.com/websocketServer'//线上环境websocket

// // 配置
Vue.prototype.payGateway = URLS.rootPay //  'https://pay-gateway.ansongqiubo.com' //线上环境充值
Vue.prototype.api =URLS.rootApi  //  'https://api.ansongqiubo.com' //线上环境
Vue.prototype.ws = URLS.rootWs //  'wss://chat.ansongqiubo.com/websocketServer'//线上环境websocket



Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js